export const useJobStatus = (status?: string) => {
    const i18n = useI18n();

    switch (status) {
        case "STARTED":
            return i18n.t('RunningWait');

        case "RUNNING":
            return i18n.t('Running');

        case "SUCCESS":
            return i18n.t('RunningSuccess');

        case "ERROR":
            return i18n.t('RunningError');

        default:
            return "";
    }
};
